import AmexGDAB2BRestaurantExperience from './AmexGDAB2BRestaurantExperience';

export default AmexGDAB2BRestaurantExperience;
